$('#respond').submit(function() {
    if ($.trim($("#email").val()) === "" || $.trim($("#author").val()) === "") {
        Swal.fire(
            'اوه مشکلی پیش آمده!',
            'شما باید فیلد های ایمیل و نام را وارد کنید',
            'error'
        )
        return false;
    }
});
